import ApiRoutes from "../../../../constants/api-routes";
import { hneAdminApi, hneAdminMultiApi } from "../../../../service";

export const createNewJob = async (body) =>
  hneAdminApi.post(`${ApiRoutes.CREATE_NEW_JOB}`, body);

export const createNewJobMulti = async (body) =>
  hneAdminMultiApi.post(`${ApiRoutes.CREATE_NEW_JOB}`, body);

export const createNewJobsCategory = async (body) =>
  hneAdminApi.post(`${ApiRoutes.CREATE_NEW_JOBS_CATEGORY}`, body);

export const getJobById = async (job_id) =>
  hneAdminApi.get(`${ApiRoutes.GET_JOBS_BY_ID}/${job_id}`);

export const getAllJobs = async (body) =>
  hneAdminApi.get(`${ApiRoutes.GET_ALL_JOBS}`, body);

export const getAllJobsCategory = async (body) =>
  hneAdminApi.get(`${ApiRoutes.GET_ALL_JOBS_CATEGORY}`, body);

export const updateJobCategory = async (body, job_category_id) =>
  hneAdminApi.put(`${ApiRoutes.UPDATE_JOBS_CATEGORY}/${job_category_id}`, body);

export const updateJobs = async (body, job_id) =>
  hneAdminApi.put(`${ApiRoutes.UPDATE_JOBS}/${job_id}`, body);

export const updateJobsMulti = async (body, job_id) =>
  hneAdminMultiApi.put(`${ApiRoutes.UPDATE_JOBS}/${job_id}`, body);

export const downloadJobApplication = async (job_id, lan) =>
  hneAdminApi.get(
    `${ApiRoutes.DOWNLOAD_APPLICATION}?job_id=${job_id}&language=${lan}`,
    {
      responseType: "blob", // 👈 This is required for downloading files
    }
  );

export const downloadGazetteApplication = async (gazette_id, lan, type) =>
  hneAdminApi.get(
    `${ApiRoutes.DOWNLOAD_GAZETTE_APPLICATION}?gazette_id=${gazette_id}&language=${lan}&type=${type}`,
    {
      responseType: "blob",
    }
  );

export const deleteJobCategory = async (job_category_id) =>
  hneAdminApi.delete(`${ApiRoutes.DELETE_JOBS_CATEGORY}/${job_category_id}`);

export const deleteJobs = async (job_id) =>
  hneAdminApi.delete(`${ApiRoutes.DELETE_JOBS}/${job_id}`);
